"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _useCostItem = require("./useCostItem");
var _default = exports.default = {
  name: 'CostItemTableTree',
  // 科目分类展示及选择组件
  props: {
    // 带 class_ 或 item_ 前缀
    value: {
      type: Array,
      default: () => []
    },
    // 获取列表的接口参数 {isDefault: 费用项是否默认，1-是，0-否, type: 类型，Default：原子科目，CustomFormula：复合科目，BizCalculate：二次计算科目，Stat：统计科目; dimension: 统计维度，Shop：店铺，Anchor：主播，Sku：单品}
    params: {
      type: Object,
      default: () => {}
    },
    // 获取列表的请求方法
    method: {
      type: [Function, String],
      default: '/v1/cost/class/item' // 最新科目分类及科目查询接口/v1/cost/class/item，在“业绩解码”和“租户后台”项目都存在该接口且为常用接口，故设置为默认值
    },
    // 是否可选择
    selectable: {
      type: Boolean,
      default: false
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否展示“显示/隐藏”列表，该值为false时changeIsShowMethod、changeIsShowParams无效
    isShowColumn: {
      type: Boolean,
      default: false
    },
    // 切换“显示/隐藏”的接口
    changeIsShowMethod: {
      type: Function,
      default: undefined
    },
    // 切换“显示/隐藏”的接口参数
    changeIsShowParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const h = this.$createElement;
    return {
      loading: false,
      columns: [{
        title: '科目分类及科目',
        dataIndex: '_title',
        fixed: 'left',
        width: 270,
        customRender: (text, record) => {
          // JSX语法渲染成html
          const {
            activeCode,
            keyword
          } = this;
          const bgColor = activeCode === record._value ? '#ff9632' : '#ffff00';
          return h("span", {
            "attrs": {
              "title": text
            },
            "domProps": {
              "innerHTML": this.$m.highlightSearchKeyword(text, keyword, `background-color:${bgColor}`)
            }
          });
        }
      }, {
        title: '科目类型',
        dataIndex: 'type',
        width: 110,
        tooltip: `<div><span class="${_useCostItem.TYPE_COLOR_MAP.Default}">原子科目：</span>从源表中选择字段，直接引用或求和/统计，形成的描述型科目</div><div><span class="${_useCostItem.TYPE_COLOR_MAP.CustomFormula}">复合科目：</span>选择依赖的度量或科目，二次加工形成的科目</div><div><span class="${_useCostItem.TYPE_COLOR_MAP.Stat}">统计科目：</span>基于其他科目，由后台自动生成统计结果的科目，不能作为“复合科目”的子项</div>`,
        customRender: text => _useCostItem.TYPE_MAP[text] || text,
        customCell: record => ({
          class: _useCostItem.TYPE_COLOR_MAP[record.type]
        })
        // filters: Object.keys(TYPE_MAP).map((key) => ({ text: TYPE_MAP[key], value: key })),
        // filterable: true
      }, {
        title: '统计维度',
        dataIndex: 'dimension',
        width: 110,
        customRender: text => _useCostItem.DIMENSION_MAP[text] || text,
        customCell: record => ({
          class: _useCostItem.DIMENSION_COLOR_MAP[record.dimension]
        })
        // filters: Object.keys(DIMENSION_MAP).map((key) => ({ text: DIMENSION_MAP[key], value: key })),
        // filterable: true
      }, {
        title: '业务类型',
        dataIndex: 'bizType',
        width: 110,
        customRender: text => _useCostItem.BIZ_TYPE_MAP[text] || text,
        customCell: record => ({
          class: _useCostItem.BIZ_TYPE_COLOR_MAP[record.bizType]
        })
        // filters: Object.keys(BIZ_TYPE_MAP).map((key) => ({ text: BIZ_TYPE_MAP[key], value: key })),
        // filterable: true
      }, {
        title: '显示/隐藏',
        dataIndex: 'isShow',
        width: 110,
        scopedSlots: {
          customRender: 'isShow'
        },
        show: () => this.isShowColumn
      }, {
        title: '是否默认',
        dataIndex: 'isDefault',
        width: 110,
        customRender: text => ['否', '是'][text],
        customCell: record => ({
          class: ['m-tips-color', 'm-type-primary'][record.isDefault]
        })
        // filters: [
        //   { text: '是', value: 1 },
        //   { text: '否', value: 0 }
        // ],
        // filterable: true
      }, {
        title: '实时查询',
        dataIndex: 'isSupport',
        width: 120,
        tooltip: '支持实时查询的科目可用于实时报表',
        customRender: text => ['不支持', '支持'][text],
        customCell: record => ({
          class: ['m-tips-color', 'm-type-primary'][record.isSupport]
        })
        // filters: [
        //   { text: '支持', value: 1 },
        //   { text: '不支持', value: 0 }
        // ],
        // filterable: true
      }, {
        title: '科目描述',
        dataIndex: 'remark',
        width: 150
      }],
      keyword: '',
      searchResult: [],
      // 搜索结果列表
      searchIndex: 0,
      // 当前显示的搜索结果索引
      defaultExpandedRowKeys: [],
      expandedRowKeys: [],
      selectedRowKeys: [],
      selectedRows: [],
      rawSource: [],
      // 转换后的原始数据
      dataSource: []
    };
  },
  computed: {
    activeCode() {
      return this.searchResult[this.searchIndex];
    },
    // 已选中的科目列表
    selectedItemList() {
      return this.selectedRows.filter(item => item._value.startsWith('item_'));
    },
    // 已选中的科目id数组
    selectedItemIds() {
      return this.selectedRowKeys.filter(item => item.startsWith('item_')).map(item => item.replace('item_', ''));
    },
    // 已选中的科目分类列表
    selectedClassList() {
      return this.selectedRows.filter(item => item._value.startsWith('class_'));
    },
    // 已选中的科目分类id数组
    selectedClassIds() {
      return this.selectedRowKeys.filter(item => item.startsWith('class_')).map(item => item.replace('class_', ''));
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selectedRowKeys = val;
      },
      immediate: true
    },
    selectedRowKeys: {
      handler(val, oldVal) {
        if (!_.isEqual(val, oldVal)) {
          this.$emit('input', val);
        }
      }
    }
  },
  created() {
    this.reload();

    // 使用 Lodash 实现防抖
    this.debouncedSearch = _.debounce(this.handleSearch, 200);
    this.debouncedScrollTo = _.debounce(this.scrollTo, 200);
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debouncedSearch.cancel();
    this.debouncedScrollTo.cancel();
  },
  methods: {
    // 获取店铺层级数据
    async getDataList() {
      try {
        this.loading = true;
        const res = typeof this.method === 'function' ? await this.method(this.params) : await _axios.default.get(this.method, this.params);
        this.init(res);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async reload(searchParams = {}) {
      try {
        if (!this.method) return;
        this.loading = true;
        const data = typeof this.method === 'function' ? await this.method({
          ...this.params,
          ...searchParams
        }) : await _axios.default.get(this.method, {
          ...this.params,
          ...searchParams
        });
        const res = await (0, _useCostItem.transformRawData)(data.classes || data, {
          multiple: this.multiple
        });
        this.dataSource = res;
        this.rawSource = res;
        // 默认展开最多10个（满足一屏展示），以免出现卡顿
        if (this.expandedRowKeys.length === 0) {
          const arr = this.$m.tree.toList(res, {
            children: '_children'
          }).map(item => item._value).slice(0, 10);
          this.expandedRowKeys = [...this.selectedRowKeys, ...arr];
          this.defaultExpandedRowKeys = this.expandedRowKeys;
        }
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    // 搜索
    handleSearch() {
      const {
        keyword,
        dataSource,
        defaultExpandedRowKeys
      } = this;
      if (!keyword) {
        this.expandedRowKeys = defaultExpandedRowKeys;
        this.searchResult = [];
      } else {
        const list = this.$m.tree.toList(dataSource, _useCostItem.TREE_CONFIG);
        const _list = list.filter(item => item._label.indexOf(keyword) > -1);
        // 符合条件的名称列表
        const targetValues = _list.map(item => item._label);
        let tempArr = [];
        const searchResult = [];
        targetValues.forEach(item => {
          // 根据名称找出路径
          const arr = this.$m.tree.findPathAll(dataSource, node => node._label === item, _useCostItem.TREE_CONFIG);
          const target = arr[0].slice(-1) || {};
          searchResult.push(target[0]?._value);
          const _values = arr[0].map(_item => _item._value);
          tempArr = [...tempArr, ..._values];
        });
        tempArr = _.uniq(tempArr);
        this.expandedRowKeys = tempArr;
        this.searchResult = searchResult;
        if (tempArr.length > 0) this.debouncedScrollTo(searchResult[0]);
      }
    },
    // 滚动到指定行
    scrollTo(rowKey, curIndex = 0) {
      this.searchIndex = curIndex;
      this.$refs.basisTableLayout.scrollTo(rowKey);
    },
    rowSelectionChange({
      selectedRowKeys,
      selectedRows,
      selectedTree
    }) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      const {
        selectedItemList,
        selectedItemIds,
        selectedClassList,
        selectedClassIds
      } = this;
      const obj = {
        selectedRowKeys,
        selectedRows,
        selectedTree,
        selectedItemList,
        selectedItemIds,
        selectedClassList,
        selectedClassIds
      };
      console.info('%c CostItemTableTree组件change事件返回值', 'color: green;', obj);
      this.$emit('change', obj);
    },
    // 店铺科目显隐设置提交接口
    async handleChangeIsShow(isShow, itemId) {
      try {
        this.loading = true;
        const params = {
          showItemId: Boolean(isShow) === true ? itemId : undefined,
          hideItemId: Boolean(isShow) === false ? itemId : undefined
        };
        await this.changeIsShowMethod({
          ...this.changeIsShowParams,
          ...params
        });
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.reload();
      } catch (e) {
        this.selectedRowKeys = [];
        this.reload();
        console.error(e);
      }
    }
  }
};